import {
  MdDashboard,
  MdPhoto,
  MdAssessment,
  MdLocationCity,
} from "react-icons/md";

import DealOverview from "pages/overview/index.jsx";
import DealTracker from "pages/deal-tracker/index.jsx";
import Photos from "pages/photos/index.jsx";
import ManageGroups from "pages/overview/groups/ManageGroups";

const routes = [
  {
    name: "Acquisitions",
    path: "/deals",
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: "Deal Overview",
        layout: "/deals",
        path: "/",
        exact: false,
        component: <DealOverview />,
      },
      {
        name: "Deal Tracker",
        layout: "",
        path: "/deal-tracker",
        exact: false,
        component: <DealTracker />,
      },
    ],
  },
  {
    name: "Photos",
    path: "/photos",
    icon: <MdPhoto className="text-inherit h-5 w-5" />,
    component: <Photos />,
  },
  {
    name: "Status",
    path: "/status",
    icon: <MdAssessment className="text-inherit h-5 w-5" />,
    component: <DealTracker />,
  },
  {
    name: "Facility Groups",
    path: "/manage-groups",
    icon: <MdLocationCity className="text-inherit h-5 w-5" />,
    component: <ManageGroups />,
  },
];

export default routes;
